export const marketPlaceConstants = {
    GET_PRODUCT_LIST_SUCCESS: 'GET_PRODUCT_LIST_SUCCESS',
    MARKETPLACE_UPDATE_SUCCESS: 'MARKETPLACE_UPDATE_SUCCESS',
    MARKETPLACE_UPDATE_REQUEST: 'MARKETPLACE_UPDATE_REQUEST',
    MARKETPLACE_UPDATE_FAILURE: 'MARKETPLACE_UPDATE_FAILURE',
    GET_ORDER_LIST_SUCCESS: 'GET_ORDER_LIST_SUCCESS'
}